// src/components/ForgotPassword.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import Loader from "../OtherComponents/Loader";
import { clearAuthToken, resetPassword } from "../../utils/auth";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const ForgotPassword = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { email, password, confirmPassword } = formData;
  const navigate = useNavigate();

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const validate = () => {
    const errors = {};
    if (!password) {
      errors.password = "Password is required";
    } else if (password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    }
    if (password !== confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
    }
    return errors;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      try {
        setLoading(true);
        await resetPassword(formData);
        await clearAuthToken();
        setTimeout(() => {
          setLoading(false);
        }, 1000);

        setTimeout(() => {
          setFormData({ email: "", password: "", confirmPassword: "" });
        }, 1000);

        setTimeout(() => {
          navigate("/thanks", { state: { show: true, page: "forgotPassword" } });
        }, 1000);

      } catch (err) {
        setTimeout(() => {
          setErrors({ server: err?.response?.data?.msg });
          toast.error(err?.response?.data?.msg);
          setLoading(false);
        }, 1000);
      }
    }
  };

  return (
    <>
      <Header />
      <ToastContainer />
      <div className="topHeading">
        <h2>Forgot Password</h2>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className="form-content">
          <form onSubmit={onSubmit} className="my-form login_form">
            <input
              type="email"
              name="email"
              value={email}
              placeholder="Email"
              onChange={onChange}
              required
            />

            <div className="inner-div password-container">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={password}
                onChange={onChange}
                placeholder="Password"
                required
              />
              <FontAwesomeIcon
                icon={showPassword ? faEyeSlash : faEye}
                onClick={() => setShowPassword(!showPassword)}
                className="password-toggle-icon"
              />
              {errors.password && <p className="error">{errors.password}</p>}
            </div>
            <div className="inner-div password-container">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={confirmPassword}
                onChange={onChange}
                placeholder="Confirm Password"
                required
              />
              <FontAwesomeIcon
                icon={showConfirmPassword ? faEyeSlash : faEye}
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="password-toggle-icon"
              />
            </div>
            {errors.confirmPassword && (
              <p className="error">{errors.confirmPassword}</p>
            )}
            <button type="submit">{!loading && "Update Password"}</button>
            {errors.server && <p className="error">{errors.server}</p>}
            <p>
              <span>Go to </span>
              <a
                href="/login"
                onClick={() => {
                  setFormData({});
                }}
              >
                Login
              </a>
            </p>
          </form>
        </div>
      )}
      <Footer />
    </>
  );
};

export default ForgotPassword;
